import img0_ from "./images/0.png";
import img1_ from "./images/1.png";
import img2_ from "./images/2.png";
import img3_ from "./images/3.png";
import img4_ from "./images/4.png";
import img5_ from "./images/5.png";
import img6_ from "./images/6.png";
import img7_ from "./images/7.png";
import img8_ from "./images/8.png";
import img9_ from "./images/9.png";

import imgblank_ from "./images/blank.png";
import imgbomb_ from "./images/bomb.png";
import imgflag_ from "./images/flag.png";

import imgwin_ from "./images/Win.png";
import imggameover_ from "./images/GameOver.png";

export const img0 = new Image();
img0.src = img0_;
export const img1 = new Image();
img1.src = img1_;
export const img2 = new Image();
img2.src = img2_;
export const img3 = new Image();
img3.src = img3_;
export const img4 = new Image();
img4.src = img4_;
export const img5 = new Image();
img5.src = img5_;
export const img6 = new Image();
img6.src = img6_;
export const img7 = new Image();
img7.src = img7_;
export const img8 = new Image();
img8.src = img8_;
export const img9 = new Image();
img9.src = img9_;

export const imgblank = new Image();
imgblank.src = imgblank_;
export const imgbomb = new Image();
imgbomb.src = imgbomb_;
export const imgflag = new Image();
imgflag.src = imgflag_;

export const imgwin = new Image();
imgwin.src = imgwin_;

export const imggameover = new Image();
imggameover.src = imggameover_;
